export default __webpack_public_path__ + "images/cube_logo.svg";